import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=6f480bb3&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"
import style0 from "./Edit.vue?vue&type=style&index=0&id=6f480bb3&prod&lang=css"
import style1 from "./Edit.vue?vue&type=style&index=1&id=6f480bb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f480bb3",
  null
  
)

export default component.exports